<template>
  <div class="allpage">
    <div class="statisticsArea" v-if="show">
      <div class="statisticsArea-header">
        <span class="bold">统计区</span>
        <span>
          <span @click="dashboardBike(1)" class="history-text cursor">未备案车</span>
          <span @click="toggleStatistical = !toggleStatistical" style="vertical-align: top;">
            <i class="iconfont icon cursor">&#xe68b;</i>
          </span>
        </span>
      </div>
      <div class="content" v-show="toggleStatistical">
        <div class="flex-1 pr8">
          <div class="title flex-between">
            <span>自行车在线量：{{statistical.bikeNum}}</span>
            <span class="pr10">站点车辆总数：{{statistical.bSiteNumTotal}}</span>
          </div>
          <div class="flex br1 pr8">
            <div class="flex-1 h270">
              <template v-if="statistical && statistical.bike && statistical.bike.length">
                <div class="num" @click="showModel(item, 1)" v-for="(item,index) in statistical.bike" :key="'bike'+index">
                  <span>{{item && item.brandName}}：</span>
                  <span class="gray-a">{{item.onlineNum}}</span>
                  <span :class="{red:item.onlineNum/item.brandBikeNum>1,blue:item.onlineNum/item.brandBikeNum<=1}">{{item.brandBikeNum ? parseInt(Math.floor((Number(item.onlineNum/item.brandBikeNum) * 100)*100)/100) : 0}}%</span>
                </div>
              </template>
              <template v-else>
                <div class="gray-a" style="margin-bottom:15px;">暂无数据</div>
              </template>
            </div>
            <div class="flex-1 h270">
              <template v-if="statistical && statistical.bike && statistical.bike.length">
                <div class="num tr" v-for="(item,index) in statistical.bike" :key="'bike-des'+index">
                  <span>站点车辆：</span>
                  <span class="gray-a">{{item.siteNum}}</span>
                  <span class="blue" @click="showModel(item, 2, 0)">查看</span>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="flex-1 pl8">
          <div class="title flex-between">
            <span>电单车在线量：{{statistical.ebikeNum}}</span>
            <span>站点车辆总数：{{statistical.eSiteNumTotal}}</span>
          </div>
          <div class="flex">
            <div class="flex-1 h270">
              <template v-if="statistical && statistical.ebike && statistical.ebike.length">
                <div class="num" @click="showModel(item, 1)" v-for="(item,index) in statistical.ebike" :key="'ebike'+index">
                  <span>{{item && item.brandName}}：</span>
                  <span class="gray-a">{{item.onlineNum}}</span>
                  <span :class="{red:item.onlineNum/item.brandEBikeNum>1,blue:item.onlineNum/item.brandEBikeNum<=1}">{{item.brandEBikeNum ? parseInt(Math.floor(Number(item.onlineNum/item.brandEBikeNum) * 100 * 100)/100) : 0}}%</span>
                </div>
              </template>
              <template v-else>
                <div class="gray-a" style="margin-bottom:15px;">暂无数据</div>
              </template>
            </div>
            <div class="flex-1 h270">
              <template v-if="statistical && statistical.ebike && statistical.ebike.length">
                <div class="num tr" v-for="(item,index) in statistical.ebike" :key="'ebike-des'+index">
                  <span>站点车辆：</span>
                  <span class="gray-a">{{item.siteNum}}</span>
                  <span class="blue" @click="showModel(item, 2, 1)">查看</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'statisticsArea',
  props: {
    statistical: {
      type: Object,
      default() {
        return {}
      }
    },
    show: {
      type: Boolean,
      default: true
    },
    aggregation: {
      type: Number
    },
    tableLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      toggleStatistical: true
    }
  },
  methods: {
    dashboardBike(legality) {
      this.$emit('dashboardBike', legality)
    },
    showModel(item, type, bikeType) {
      // type 1-企业，2-查看
      const params = {
        ...item,
        type,
        bikeType
      }
      this.$emit('showModel', params)
    }
  }
}
</script>

<style lang="less" scoped>
.allpage {
  flex: 1;
  margin-right: 4px;
  // height: 323px;
  height: auto;
  background-color: #FFF;
  // .h270 {
  //   height: 270px;
  // }
  .statisticsArea {
    padding: 0 16px;
    .statisticsArea-header {
      height: 42px;
      line-height: 42px;
      display: flex;
      justify-content: space-between;
      font-size:14px;
      font-family:PingFangSC-Medium,PingFang SC;
      color:rgba(111,117,128,1);
      border-bottom: 1px solid #EBEBEB;
      .bold {
        font-weight: bold;
      }
      .icon {
        font-size: 18px;
        color: #999;
      }
      .history-text {
        font-size:12px;
        color: #1F8FFB;
        margin-right: 30px;
      }
    }
    .content {
      display: flex;
      .flex {
        display: flex;
        justify-content: space-between;
      }
      .flex-1 {
        flex: 1;
        .title {
          font-size:14px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:bold;
          color:rgba(0,0,0,0.85);
          padding: 16px 0 24px 0;
        }
        .num {
          margin-bottom: 10px;
          font-size:12px;
          color:rgba(0,0,0,0.65);
          span {
            cursor: pointer;
          }
          .gray-a {
            color:rgba(0,0,0,0.45);
            margin-right: 8px;
          }
          .blue {
            color: #1F8FFB;
          }
          .red {
            color: #ED462F;
            margin-right: 8px;
          }
        }
        .tr {
          text-align: right;
        }
      }
      .br1 {
        border-right: 1px solid #EBEBEB;
      }
      .pr8 {
        padding-right: 8px;
      }
      .pl8 {
        padding-left: 8px;
      }
    }
  }
  .flex-between {
    display: flex;
    justify-content: space-between;
  }
  .pr10 {
    padding-right: 10px;
  }
}
</style>
